import { Box, type BoxProps } from './Box';

export type InlineProps = Omit<BoxProps, 'display' | 'flexDirection'>;

export function Inline({ gap = 8, ...rest }: InlineProps) {
    return <Box display="flex" flexDirection="row" gap={gap} {...rest} />;
}
